export default __webpack_public_path__ + "static/media/pd.c5b3115c.svg";